import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Input, Modal } from "../../../../components";
import { getMemberByEmail_V2 } from "../../../../Services_V2/Member.service";
import { showError } from "../../../../utils/error";
import { setLocalStorageItem } from "../../../../utils/localStorage";

interface IProps {
  open: boolean;
  onClose: () => void;
  initialEmail?: string;
}

const EmailMemberModal: React.FC<IProps> = ({
  open,
  onClose,
  initialEmail = "",
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFetchMember = async () => {
    if (!email) {
      setError("Please enter an email.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await getMemberByEmail_V2({ email });
      if (res?.success && res.data) {
        setLocalStorageItem("memberDetails", JSON.stringify(res.data));
        onClose();
      } else {
        onClose();
        showError("Member not found for email");
      }
    } catch (err) {
      showError(err);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} showClose title="Enter Member Email">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Input
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          placeholder={initialEmail || "test@example.com"}
        />

        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleFetchMember}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Get Member Details"}
        </Button>
      </Box>
    </Modal>
  );
};

export default EmailMemberModal;
